import Effects from 'effects/Effects.js';
import {bulkUpdate} from 'utils/bulkUpdate.js';
import Tone from 'tone';
import {AudioParamPercentageValueParameter,
        AbstractAudioParamParameter} from 'parameters/AbstractAudioParamParameter.js';

class DelayEffect extends Effects.Effect {
    constructor(sequencerEngine) {
        super("Delay", () => new Tone.FeedbackDelay(new Tone.Time('16n'), 0.5), sequencerEngine);
        this.delayTime = '16n';
        this.rateParameter = new AbstractAudioParamParameter(
           'Delay Rate',
            this.effectNode.delayTime, (o, x) => {
                this.rawDelayRate = x;
                if (typeof x === 'number') {
                    x /= 1000;
                }
                
                if (x._val) {
                    if (typeof x._val == 'object') {
                        // okay wtf makes this happen?
                        x = new Tone.Time(x._val._val);
                    } else {
                        x = new Tone.Time(x._val);
                    }
                }
                this.effectNode.delayTime.linearRampToValueAtTime(new Tone.Time(x), 0.001);
            },
            {
                documentation: "The time between each individual echo",
                min: 0.0001,
                max: 1,
                unit: '',
                defaultValue: new Tone.Time('8n')
            });
                                           

        this.rawDelayRate = '8n';
        this.isSynced = true;

        this.registerParameter(this.rateParameter);

        this.feedbackParameter = new AudioParamPercentageValueParameter(
            'Feedback', this.effectNode.feedback);
        this.registerParameter(this.feedbackParameter);
        this.updateInitialValues();
    }

    get documentation() {
        return "A basic echo effect.";
    }

    set rate(x) {
        this.rateParameter.set(x);
    }

    get rate() {
        return this.rateParameter.get(true);
    }

    // feedback from 0 to 1
    setFeedback(feedback) {
        this.feedbackParameter.set(feedback);
    }

    getFeedback() {
        if (!this.effectNode) {
            return 0;
        }
        return this.effectNode.feedback.value;
    }

    onBPMUpdated() {
        if (this.isSynced) {
            this.rateParameter.set(this.rawDelayRate, true);
        }
    }

    getDelayTime() {
        return this.delayTime;
    }

    getJson() {
        let rate = this.rate;
        if (typeof rate === 'object' &&
            rate.toSeconds) {
            rate = this.rate.toSeconds();
        }
        let json = {
            ... super.getJson(),
            name: this.name,
            enabled: this.enabledParameter.get(),
            feedback: this.effectNode.feedback.value,
            isSynced: this.isSynced,
            rate: rate,
            rawDelayRate: this.rawDelayRate,
        };

        json = this.saveParameterToJson(json, 'feedbackParameter', this.feedbackParameter);
        json = this.saveParameterToJson(json, 'rateParameter', this.rateParameter);

        return json;
    }

    getEffectCopy(sequencerEngine=this.sequencerEngine, ignoreId=true) {
        var copy = new DelayEffect(sequencerEngine);
        copy.fromJson(this.getJson(), ignoreId);
        return copy;
    }

    fromJson(json, isCopy) {
        let bulk = super.fromJson(json, isCopy);
        if ('feedback' in json) {
            bulkUpdate(this.feedbackParameter, json.feedback, bulk);
        } 

        if ('delayTime' in json) {
            bulkUpdate(this.rateParameter, json.delayTime, bulk);
        }

        if ('rate' in json) {
            bulkUpdate(this.rateParameter, json.rate, bulk);
        }

        if ('rawDelayRate' in json) {
            this.rawDelayRate = json.rawDelayRate;
        }

        if ('isSynced' in json) {
            this.isSynced = json.isSynced;
        }

        return {
            ... bulk,
            ... this.loadParameterFromJson(json, 'feedbackParameter', this.feedbackParameter, isCopy),
            ... this.loadParameterFromJson(json, 'rateParameter', this.rateParameter, isCopy)
        };
    }
}

export default DelayEffect;
